<template>
  <div>
    Homepage
  </div>
</template>

<script lang="ts" setup>

</script>

<style>

</style>